import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      sentry: Sentry,
    },
  }
})
